import Swal from "sweetalert2";

// let form = document.forms['check-enrollment'];
// let token = form.querySelector('[name="_token"]')

// form.addEventListener('submit', function (e) {
//     let data = new FormData()
//     data.append('cedula', form['cedula'].value)
//     data.append('email', form['email'].value)
//     data.append('type', 'current_event')
//     e.preventDefault()

//     checkEnrollment(data, Swal.fire(
//         'Estas registrado',
//         'Uno de los datos (Email, Cedula) coincide con los datos de un participante registrado',
//         'success'
//     ), Swal.fire(
//         'Error',
//         'Ninguno de los datos que proporcionaste coinciden con un participante registrado',
//         'error'
//     ))
// })

function checkEnrollment(url, token, data, fnSuccess, fnErr){
    fetch(url, {
        method: 'POST',
        body: data,
        headers: {
            "X-CSRF-TOKEN": token,
        }
    }).then(response => {
        if (response.ok) {
            return response.json().then(function(data){
                return fnSuccess(data)
            })
        }

        return fnErr()
    }).catch(e => {
        console.error("Error: ", e)
        fnErr()
    })
}

export default checkEnrollment;